import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  tooltip: {
    padding: '9px',
    background: '#147975',
    borderRadius: '8px',
    textAlign: 'center',
    fontSize: '14px',
    marginTop: 8,
    position: 'relative',
    marginBottom: 0,
  },
  popper: {
    zIndex: theme.isMobile ? 1500 : 1401
  },
  arrow: {
    '&:before': {
      border: '1px solid #147975'
    },
    left: 'auto !important',
    color: '#147975',
    margin: 0
  },
  text: {
    fontSize: '14px',
    color: '#FFFFFF',
    display: 'inline',
    padding: '5px'
  },
  icon: {
    color: '#FFFFFF',
    display: 'inline',
    width: '11px',
    height: '11px',
    position: 'relative',
    top: '-1.5px'
  },
  closeButton: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    fontWeight: 500
  }
}));

const AlertToolTip = (props) => {
  const classes = useStyles();
  const [display, setDisplay] = useState();
  const { tooltipText, localStorageName, openTooltip } = props;
  const isDisableTooltipInPopup = JSON.parse(localStorage.getItem(localStorageName));
  const handleClick = () => {
    localStorage.setItem(localStorageName, true);
    setDisplay(false);
  };
  useEffect(() => {
    setTimeout(
      () => setDisplay(true),
      1000,
    );
  }, []);
  return (
    <Tooltip
      interactive
      title={(
        <div style={{ marginTop: '5px' }}>
          <Typography className={classes.text}>
            {tooltipText}
          </Typography>
          <IconButton
            className={classes.icon}
            onClick={handleClick}
          >
            <CloseIcon
              className={classes.closeButton}
            />
          </IconButton>
        </div>
      )}
      open={display && !isDisableTooltipInPopup && openTooltip ? () => true : false}
      placement="bottom-start"
      arrow
      PopperProps={props.PopperProps}
      classes={{
        tooltip: classes.tooltip,
        popper: classes.popper,
        arrow: classes.arrow
      }}
    >
      {props.children}
    </Tooltip>
  );
};

export default AlertToolTip;
